<div class="loader-overlay" *ngIf="loaderService.loading$ | async">
  <mat-progress-spinner mode="indeterminate" color="primary" diameter="50"></mat-progress-spinner>
</div>
